<div class="site-page-header-ghost-wrapper">
  <nz-page-header [nzGhost]="false">
    <nz-page-header-title class="ml4">Job Applications</nz-page-header-title>
  </nz-page-header>
</div>

<!-- Filters Row -->
<div nz-row [nzGutter]="16" class="mt4">
  <!-- Search -->
  <div nz-col nzLg="8" nzMd="8" nzSm="24" nzXs="24" class="mb5">
    <nz-form-label nzFor="search">Search</nz-form-label>
    <nz-input-group [nzSuffix]="suffixIconSearch">
      <input
        type="text"
        nz-input
        placeholder="Search by name, email, mobile"
        ngModel
        (ngModelChange)="searchData($event)"
      />
    </nz-input-group>
    <ng-template #suffixIconSearch>
      <i nz-icon nzType="search"></i>
    </ng-template>
  </div>

  <!-- Gender Filter -->
  <div nz-col nzLg="8" nzMd="8" nzSm="24" nzXs="24" class="mb5">
    <nz-form-label>Gender</nz-form-label>
    <nz-select
      nzAllowClear
      nzPlaceHolder="Filter by Gender"
      [(ngModel)]="selectedGender"
      (ngModelChange)="onGenderChange($event)"
      style="width: 100%"
    >
      <nz-option nzValue="Male" nzLabel="Male"></nz-option>
      <nz-option nzValue="Female" nzLabel="Female"></nz-option>
      <nz-option nzValue="Other" nzLabel="Other"></nz-option>
      <nz-option
        nzValue="Prefer not to say"
        nzLabel="Prefer not to say"
      ></nz-option>
    </nz-select>
  </div>

  <!-- Date Range Filter -->
  <div nz-col nzLg="8" nzMd="8" nzSm="24" nzXs="24" class="mb5">
    <nz-form-label>Created At</nz-form-label>
    <nz-range-picker
      [(ngModel)]="dateRange"
      (ngModelChange)="onDateRangeChange($event)"
      style="width: 100%"
    ></nz-range-picker>
  </div>
</div>

<!-- Job Applications Table -->
<nz-table
  #applicationTable
  [nzData]="applicationList"
  [nzLoading]="loading"
  [nzTotal]="totalDataCount"
  [(nzPageSize)]="pageSize"
  [nzPageIndex]="pageIndex"
  [nzFrontPagination]="false"
  (nzQueryParams)="onQueryParamsChange($event)"
  nzShowSizeChanger
  [nzScroll]="{ x: '1800px' }"
>
  <thead>
    <tr>
      <th nzColumnKey="name" [nzSortFn]="true" nzWidth="200px">Name</th>
      <th nzWidth="220px">Email</th>
      <th nzWidth="210px">Account Details</th>
      <th nzWidth="150px">Mobile</th>
      <th nzWidth="130px">DOB</th>
      <th nzWidth="100px">Gender</th>
      <th nzWidth="160px">City</th>
      <th nzWidth="160px">State</th>
      <th nzWidth="120px">Applied At</th>
      <th nzWidth="120px">Attachment</th>
      <th class="text-right" nzWidth="90px">Action</th>
    </tr>
  </thead>

  <tbody>
    <tr *ngFor="let data of applicationTable.data">
      <!-- Applicant Name -->
      <td>
        <div class="applicant-name" *ngIf="data.name">
          <i nz-icon nzType="user" nzTheme="outline" class="mr1"></i>
          <span class="ellipsis">{{ data.name }}</span>
        </div>
        <span *ngIf="!data.name">—</span>
      </td>
      <!-- Email -->
      <td>
        <div *ngIf="data.email">
          <span class="ellipsis">{{ data.email }}</span>
        </div>
        <span *ngIf="!data.email">—</span>
      </td>
      <!-- Linked Account Details -->
      <td>
        <div *ngIf="data.user" class="account-details">
          <div class="mb2">
            <i nz-icon nzType="idcard" nzTheme="outline" class="mr1"></i>
            <strong>{{ data.user.name }}</strong>
          </div>
          <div class="mb2">
            <i nz-icon nzType="mail" nzTheme="outline" class="mr1"></i>
            <span>{{ data.user.email }}</span>
          </div>
          <div>
            <i nz-icon nzType="phone" nzTheme="outline" class="mr1"></i>
            <span>{{ data.user.mobile }}</span>
          </div>
        </div>
        <span *ngIf="!data.user">—</span>
      </td>
      <!-- Mobile -->
      <td>
        <div *ngIf="data.mobile">
          <i nz-icon nzType="phone" nzTheme="outline" class="mr1"></i>
          {{ data.mobile }}
        </div>
        <span *ngIf="!data.mobile">—</span>
      </td>
      <!-- DOB -->
      <td>
        <nz-tag nzColor="default" *ngIf="data.dob">{{
          data.dob | date: "dd MMM yyyy"
        }}</nz-tag>
        <span *ngIf="!data.dob">—</span>
      </td>
      <!-- Gender -->
      <td>
        <nz-tag
          [nzColor]="
            data.gender === 'Male'
              ? 'blue'
              : data.gender === 'Female'
                ? 'pink'
                : 'purple'
          "
          *ngIf="data.gender"
          >{{ data.gender }}</nz-tag
        >
        <span *ngIf="!data.gender">—</span>
      </td>
      <!-- City -->
      <td>
        <nz-tag
          nzColor="cyan"
          *ngIf="data.city"
          nzTooltipTitle="{{ data.city }}"
          nz-tooltip
        >
          <i nz-icon nzType="environment" nzTheme="outline"></i>
          <span class="ellipsis">{{ data.city }}</span>
        </nz-tag>
        <span *ngIf="!data.city">—</span>
      </td>
      <!-- State -->
      <td>
        <nz-tag
          nzColor="geekblue"
          *ngIf="data.state"
          nzTooltipTitle="{{ data.state }}"
          nz-tooltip
        >
          <span class="ellipsis">{{ data.state }}</span>
        </nz-tag>
        <span *ngIf="!data.state">—</span>
      </td>
      <!-- Applied At -->
      <td>{{ data.createdAt | date: "dd MMM yyyy" }}</td>
      <!-- Attachment -->
      <td>
        <a
          *ngIf="data.resume || data.attachment"
          [href]="
            data.resume?.path
              ? mediaBaseUrl + data.resume.path
              : data.attachment?.path
                ? mediaBaseUrl + data.attachment.path
                : mediaBaseUrl + (data.resume || data.attachment)
          "
          target="_blank"
          nz-button
          nzType="default"
          nzSize="small"
          nzTooltipTitle="View / Download"
          nz-tooltip
        >
          <i nz-icon nzType="paper-clip"></i> View
        </a>
        <span *ngIf="!data.resume && !data.attachment">—</span>
      </td>
      <td class="action-buttons">
        <!-- Delete -->
        <a
          class="action-button delete"
          nz-button
          nzDanger
          nz-popconfirm
          nzPopconfirmTitle="Are you sure you want to delete this application?"
          (nzOnConfirm)="deleteApplication(data._id)"
          nzTooltipTitle="Delete"
          nzTooltipPlacement="topCenter"
          nz-tooltip
        >
          <i nz-icon nzType="delete" nzTheme="outline"></i>
        </a>
      </td>
    </tr>
  </tbody>
</nz-table>
